export class Validator {

	static passwordCriteria = "Password must contain at least 8 characters.";
	static passwordMatchError = "Passwords do not match.";

	static minLength = 8;

	static isInvalidPassword(newPassword) {
		if (newPassword.length === 0) return false;
		return newPassword.length < this.minLength;
	}

	static isPasswordMismatch(newPassword, confirmNewPassword) {
		if (confirmNewPassword.length === 0) return false;
		return newPassword !== confirmNewPassword;
	}

	static disableSubmitButton(newPassword, confirmNewPassword) {
		return newPassword.length < this.minLength || newPassword !== confirmNewPassword;
	}
};